import { gql, TypedDocumentNode } from '@apollo/client'

import { Data, Variables } from './types'

export const GET_AB_TESTS_FOR_TABLE: TypedDocumentNode<Data, Variables> = gql`
  query getAbTests($first: Int, $last: Int, $terms: [String!], $sort: AbTestSortInput) {
    abTests(first: $first, last: $last, terms: $terms, sort: $sort) {
      nodes {
        id
        domain {
          name
        }
        endedAt
        name
        startedAt
        status
        updatedAt
        usedVariantsData {
          name
          reportedKeyValue
        }
      }

      totalCount
    }
  }
`
